/**
 * ZIP-code popup and region-based link rewriting.
 * When user selects ZIP (LA / SF / Honolulu): rewrite all collection and product links
 * to point to the duplicated versions (-la, -sf, -hnl). Nothing is hidden — links are replaced.
 * Cookie: store_city = los_angeles | honolulu | san_francisco | other
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'store_city';
  var COOKIE_DAYS = 365;
  var BODY_ATTR = 'data-store-city';
  var ORIGINAL_HREF = 'data-original-href';
  var REWRITTEN_ATTR = 'data-region-rewritten';
  var DATA_REGION = 'data-region';

  // Full ZIP code lists per location
  var LA_ZIPS = ["90001","90002","90003","90004","90005","90006","90007","90008","90010","90011","90012","90013","90014","90015","90016","90017","90018","90019","90020","90021","90022","90023","90024","90025","90026","90027","90028","90029","90031","90032","90033","90034","90035","90036","90037","90038","90039","90040","90041","90042","90043","90044","90045","90046","90047","90048","90049","90056","90057","90058","90059","90061","90062","90063","90064","90065","90066","90067","90068","90069","90071","90074","90077","90079","90084","90088","90089","90090","90094","90095","90096","90099","90101","90102","90103","90189","90201","90210","90211","90212","90220","90221","90222","90230","90232","90240","90241","90242","90245","90247","90248","90249","90250","90254","90255","90260","90261","90262","90266","90270","90272","90274","90275","90277","90278","90280","90290","90291","90292","90293","90301","90302","90303","90304","90305","90311","90313","90397","90398","90401","90402","90403","90404","90405","90501","90502","90503","90504","90505","90506","90601","90602","90603","90604","90605","90606","90612","90620","90621","90623","90630","90631","90638","90639","90640","90650","90659","90660","90670","90680","90701","90703","90706","90710","90712","90713","90715","90716","90717","90720","90723","90731","90732","90740","90744","90745","90746","90747","90755","90802","90803","90804","90805","90806","90807","90808","90810","90813","90814","90815","90822","90831","90833","90834","90835","90840","90842","90844","90845","90846","90847","90848","90888","90895","90899","91001","91006","91007","91008","91010","91011","91016","91020","91024","91030","91040","91042","91101","91103","91104","91105","91106","91107","91108","91110","91121","91123","91124","91125","91126","91129","91131","91182","91184","91185","91188","91189","91191","91199","91201","91202","91203","91204","91205","91206","91207","91208","91210","91214","91306","91316","91321","91324","91325","91326","91329","91330","91331","91335","91340","91342","91343","91344","91345","91351","91352","91356","91364","91371","91382","91387","91388","91399","91401","91402","91403","91405","91406","91411","91423","91436","91470","91482","91495","91496","91497","91499","91501","91502","91504","91505","91506","91521","91522","91523","91526","91601","91602","91604","91605","91606","91607","91608","91611","91612","91702","91706","91722","91723","91724","91731","91732","91733","91735","91740","91741","91744","91745","91746","91748","91750","91754","91755","91756","91765","91766","91767","91768","91770","91771","91772","91773","91775","91776","91780","91789","91790","91791","91792","91795","91797","91799","91801","91803","91804","91841","92647","92648","92649","92655","92683","92703","92704","92706","92708","92801","92802","92804","92805","92806","92807","92809","92821","92823","92831","92832","92833","92835","92840","92841","92843","92844","92845","92850","92861","92865","92866","92867","92868","92870","92886","92899","93510","93563"];
  var HONOLULU_ZIPS = ["96701","96706","96707","96709","96712","96717","96730","96731","96734","96744","96759","96762","96782","96786","96789","96791","96792","96795","96797","96801","96802","96803","96804","96805","96806","96807","96808","96809","96810","96811","96812","96813","96814","96815","96816","96817","96818","96819","96820","96821","96822","96823","96824","96825","96826","96827","96828","96830","96835","96836","96837","96838","96839","96840","96841","96842","96843","96844","96845","96846","96847","96848","96849","96850","96853","96854","96857","96858","96859","96860","96861","96862","96863","96898"];
  var VENTURA_ZIPS = ["91320","93012","91360","91361","91362","93010","93033","93042","90265","91301","91363","91377","93004","93021","93030","93035","93036","93041","93043","93066","90263","91302","91307","93003","93060","93063","93064","93065","93093","93099","91303","91304","91311","91367","93009","93015","91355","91381","93001","93022"];
  var SF_ZIPS = ["94002","94003","94005","94010","94011","94012","94013","94014","94015","94016","94017","94018","94019","94022","94023","94024","94025","94026","94027","94028","94029","94030","94031","94035","94037","94038","94039","94040","94041","94042","94043","94044","94045","94059","94061","94062","94063","94064","94065","94066","94067","94070","94071","94074","94080","94083","94089","94096","94098","94099","94101","94102","94103","94104","94105","94106","94107","94108","94109","94110","94111","94112","94114","94115","94116","94117","94118","94119","94120","94121","94122","94123","94124","94125","94126","94127","94128","94129","94130","94131","94132","94133","94134","94135","94136","94137","94138","94139","94140","94141","94142","94143","94144","94145","94146","94147","94150","94151","94152","94153","94154","94155","94156","94157","94158","94159","94160","94161","94162","94163","94164","94165","94166","94167","94168","94169","94170","94171","94172","94175","94177","94188","94199","94301","94302","94303","94304","94305","94306","94307","94308","94309","94310","94401","94402","94403","94404","94405","94406","94407","94408","94409","94497","94501","94502","94503","94506","94507","94510","94516","94517","94518","94519","94520","94521","94522","94523","94524","94525","94526","94527","94528","94529","94530","94536","94537","94538","94539","94540","94541","94542","94543","94544","94545","94546","94547","94549","94552","94553","94555","94556","94557","94559","94560","94563","94564","94565","94566","94568","94569","94570","94572","94575","94577","94578","94579","94580","94582","94583","94586","94587","94588","94589","94590","94591","94592","94595","94596","94597","94598","94601","94602","94603","94604","94605","94606","94607","94608","94609","94610","94611","94612","94613","94614","94615","94617","94618","94619","94620","94621","94622","94623","94624","94625","94626","94627","94643","94649","94659","94660","94661","94662","94666","94701","94702","94703","94704","94705","94706","94707","94708","94709","94710","94712","94720","94801","94802","94803","94804","94805","94806","94807","94808","94820","94850","94901","94903","94904","94912","94913","94914","94915","94920","94924","94925","94930","94933","94938","94939","94941","94942","94945","94946","94947","94948","94949","94950","94952","94953","94954","94955","94956","94957","94960","94963","94964","94965","94966","94970","94973","94974","94975","94976","94977","94978","94979","94998","94999","95002","95476"];

  function getCityByZip(zip) {
    var z = String(zip).replace(/\D/g, '').slice(0, 5);
    if (z.length < 5) return null;
    if (LA_ZIPS.indexOf(z) >= 0) return 'los_angeles';
    if (HONOLULU_ZIPS.indexOf(z) >= 0) return 'honolulu';
    if (SF_ZIPS.indexOf(z) >= 0) return 'san_francisco';
    if (VENTURA_ZIPS.indexOf(z) >= 0) return 'ventura';
    return 'other';
  }

  /** Cookie/cart may have full (los_angeles) or short (la) — always return la|sf|hnl or null */
  function cityToRegion(city) {
    var c = (city || '').toLowerCase().trim();
    if (c === 'los_angeles' || c === 'la') return 'la';
    if (c === 'san_francisco' || c === 'sf') return 'sf';
    if (c === 'honolulu' || c === 'hnl') return 'hnl';
    if (c === 'ventura' || c === 'vc') return 'vc';
    return null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;expires=' + d.toUTCString() + ';SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  /** Map URL slug (query value, param name, path segment, hash) → canonical store city id */
  function slugToCity(slug) {
    var c = String(slug || '').toLowerCase().trim();
    if (!c) return null;
    if (c === 'honolulu' || c === 'hnl') return 'honolulu';
    if (c === 'san_francisco' || c === 'sf' || c === 'san-francisco' || c === 'sanfrancisco') return 'san_francisco';
    if (c === 'los_angeles' || c === 'la' || c === 'los-angeles' || c === 'losangeles') return 'los_angeles';
    if (c === 'ventura' || c === 'vc' || c === 'ventura-county' || c === 'ventura_county') return 'ventura';
    return null;
  }

  /** Canonical home URL: ?city=… (LA остаётся чистым «/») */
  function homeUrlWithCityQuery(city) {
    if (city === 'los_angeles') return '/';
    if (city === 'honolulu') return '/?city=honolulu';
    if (city === 'san_francisco') return '/?city=san_francisco';
    if (city === 'ventura') return '/?city=ventura';
    return '/';
  }

  /**
   * Parse city from URL (in order):
   * - ?city= (канон, как раньше)
   * - Hash #honolulu (старые ссылки / return_to)
   * - Pretty query: город как имя параметра
   * - Path: /honolulu
   */
  function getCityFromUrl() {
    var params = typeof URLSearchParams !== 'undefined' && window.location.search ? new URLSearchParams(window.location.search) : null;
    if (params && params.has('city')) {
      var fromCityParam = slugToCity(params.get('city'));
      if (fromCityParam) return fromCityParam;
    }
    var hash = (window.location.hash || '').replace(/^#/, '').split(/[?&]/)[0];
    if (hash) {
      var fromHash = slugToCity(decodeURIComponent(hash));
      if (fromHash) return fromHash;
    }
    if (params) {
      var keys = [];
      params.forEach(function (_v, k) {
        keys.push(k);
      });
      var i;
      for (i = 0; i < keys.length; i++) {
        var fromKey = slugToCity(keys[i]);
        if (fromKey) return fromKey;
      }
    }
    var path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    if (path !== '/' && path.indexOf('/') === 0) {
      var segments = path.slice(1).split('/').filter(Boolean);
      if (segments.length === 1) {
        var fromPath = slugToCity(segments[0]);
        if (fromPath) return fromPath;
      }
    }
    return null;
  }

  /** City for rewriting: cookie, then URL (?city= / hash / path / pretty), then cart, then body */
  function getCityForRewrite() {
    var city = getCookie(COOKIE_NAME);
    if (city) return city;
    city = getCityFromUrl();
    if (city) return city;
    var fromCart = typeof window.__STORE_CITY_FROM_CART__ !== 'undefined' && window.__STORE_CITY_FROM_CART__;
    if (fromCart && String(fromCart).trim()) return String(fromCart).trim();
    var bodyCity = document.body.getAttribute(BODY_ATTR);
    if (bodyCity && /^(la|sf|hnl|vc|los_angeles|san_francisco|honolulu|ventura)$/i.test(bodyCity)) return bodyCity;
    return null;
  }

  function isHomePath() {
    var path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    if (path === '' || path === '/' || path === '/index' || path === '/pages/index') return true;
    if (path.indexOf('/') === 0 && path.length > 1) {
      var segments = path.slice(1).split('/').filter(Boolean);
      if (segments.length === 1 && slugToCity(segments[0])) return true;
    }
    return false;
  }

  function getCityDisplayName(city) {
    if (!city) return 'Change Location';
    var c = String(city).toLowerCase();
    if (c === 'los_angeles' || c === 'la') return 'Los Angeles County';
    if (c === 'san_francisco' || c === 'sf') return 'San Francisco Bay Area';
    if (c === 'honolulu' || c === 'hnl') return 'Honolulu (Oahu)';
    if (c === 'ventura' || c === 'vc') return 'Ventura County';
    return 'Change Location';
  }

  function updateTriggerLabel(city) {
    var label = getCityDisplayName(city);
    var trigger = document.getElementById('zip-popup-trigger');
    if (trigger) {
      var textEl = trigger.querySelector('.zip-popup-trigger-text');
      if (textEl) textEl.textContent = label;
      trigger.setAttribute('aria-label', label);
      trigger.setAttribute('title', label);
    }
    document.querySelectorAll('.gh-actions__location-btn[data-open-zip-popup]').forEach(function (el) {
      el.setAttribute('aria-label', label);
      el.setAttribute('title', label);
    });
  }

  /** Strip -la, -sf, -hnl or trailing hyphen from handle to get base handle (theme may output "harmony-") */
  function getHandleBase(handle) {
    if (!handle || typeof handle !== 'string') return '';
    var base = handle.replace(/-la$|-sf$|-hnl$|-vc$/i, '').trim();
    base = base.replace(/-+$/, ''); // trim trailing hyphen(s) so "harmony-" -> "harmony"
    return base;
  }

  /** Get region from handle for filtering: la, sf, hnl, or base */
  function getRegionFromHandle(handle) {
    if (!handle || typeof handle !== 'string') return 'base';
    var h = handle.toLowerCase().replace(/-+$/, '').trim();
    if (h.length >= 3 && h.slice(-3) === '-la') return 'la';
    if (h.length >= 3 && h.slice(-3) === '-sf') return 'sf';
    if (h.length >= 4 && h.slice(-4) === '-hnl') return 'hnl';
    if (h.length >= 3 && h.slice(-3) === '-vc') return 'vc';
    return 'base';
  }

  function getHandleFromHref(href) {
    if (!href) return '';
    var m = href.match(/\/(?:collections|products)\/([^/?]+)/);
    return m ? m[1] : '';
  }

  /** LA uses base handles (no -la); treat base as matching when filter is la. SF/HNL use -sf/-hnl only. */
  function regionMatchesFilter(region, cardRegion) {
    if (!region) return true;
    if (cardRegion === region) return true;
    if (region === 'la' && cardRegion === 'base') return true;
    return false;
  }

  /** Search UI + product page recommendations («BUY WITH») — same duplicate filter as predictive search. */
  function inRegionDuplicateFilterContext(el) {
    var searchContainers = document.querySelectorAll('.predictive-search, .search-modal, [class*="predictive"], [class*="search-modal"], #Search-In-Modal');
    var i;
    for (i = 0; i < searchContainers.length; i++) {
      if (searchContainers[i].contains(el)) return true;
    }
    var mainEl = document.querySelector('main');
    var isSearchPage = window.location.pathname === '/search' || (mainEl && mainEl.classList && mainEl.classList.contains('search'));
    if (isSearchPage && mainEl && mainEl.contains(el)) return true;
    if (window.location.pathname.indexOf('/collections/') === 0 && mainEl && mainEl.contains(el)) {
      // NEVER dedup the main collection product grid — a collection page must show exactly its
      // curated products to every visitor (any region). Dedup here was emptying base + regional
      // grids for non-LA visitors. Other blocks on the page (search/recs) still dedup.
      if (el.closest && el.closest('#product-grid, #ProductGridContainer')) return false;
      return true;
    }
    if (el.closest && el.closest('#product-grid, [id^="product-grid"], [class*="collection-list"], .collection')) return true;
    if (el.closest && el.closest('[class*="featured-collection"]')) {
      var __isHome = (window.location.pathname === '/' || window.location.pathname === '');
      return !__isHome; // homepage featured-collection (base-only bestsellers) must NOT be region-hidden
    }
    // recommendations / related / complementary sections are NOT region-deduped — keep recommended cards visible (fixes orphan "BUY WITH")
    return false;
  }

  /** Mark product/collection links and card parents with data-region so we can hide duplicates in search.
   * Use original href (before rewrite) when present, so each card keeps its real region (la/sf/hnl/base). */
  function markRegionOnLinks() {
    var links = document.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]');
    var cardSel = '[class*="card"], [class*="product"], [class*="search"], [class*="predictive"], .grid__item, .list-view-item, li';
    links.forEach(function (link) {
      if (link.closest('#zip-code-popup')) return;
      var href = link.getAttribute(ORIGINAL_HREF) || link.getAttribute('href') || '';
      var handle = getHandleFromHref(href);
      var r = getRegionFromHandle(handle);
      var base = getHandleBase(handle);
      link.setAttribute(DATA_REGION, r);
      link.setAttribute('data-region-base', base);
      var parent = link.closest(cardSel);
      if (parent && parent !== link) { parent.setAttribute(DATA_REGION, r); parent.setAttribute('data-region-base', base); }
      var li = link.closest('li');
      if (li) { li.setAttribute(DATA_REGION, r); li.setAttribute('data-region-base', base); }
    });
  }

  /** In search + recommendations: hide cards that are not for the selected region */
  function isRegionalCollectionPage() {
    return /\/collections\/[^\/]*-(?:vc|hnl|sf)(?:\/|$)/.test(window.location.pathname);
  }
  function hideDuplicateCards(region) {
    markRegionOnLinks();
    region = region || 'la';
    if (isRegionalCollectionPage()) return; // products already correct region -> never hide the grid
    var regionClones = {};
    if (region !== 'la') {
      document.querySelectorAll('[' + DATA_REGION + ']').forEach(function (el) {
        if (!inRegionDuplicateFilterContext(el)) return;
        if (el.getAttribute(DATA_REGION) === region) {
          var b = el.getAttribute('data-region-base');
          if (b) regionClones[b] = true;
        }
      });
    }
    document.querySelectorAll('[' + DATA_REGION + ']').forEach(function (el) {
      if (!inRegionDuplicateFilterContext(el)) return;
      var r = el.getAttribute(DATA_REGION);
      var show;
      if (region === 'la') {
        show = (r === 'la' || r === 'base');
      } else if (r === region) {
        show = true;
      } else if (r === 'base' || r === 'la') {
        var b = el.getAttribute('data-region-base');
        show = !(b && regionClones[b]);
      } else {
        show = false;
      }
      el.style.display = show ? '' : 'none';
    });
  }

  function showAllSearchCards() {
    markRegionOnLinks();
    document.querySelectorAll('[' + DATA_REGION + ']').forEach(function (el) {
      if (inRegionDuplicateFilterContext(el)) el.style.display = '';
    });
  }

  /** Rewrite one link to point to region version.
   * Rules:
   * - LA: use base handle (no suffix) because base products already exist
   * - SF/HNL: use duplicated handles (-sf / -hnl)
   */
  function rewriteLink(link, region) {
    if (!region || String(region).length === 0) return; // never rewrite with empty region (would make "harmony-")
    if (isRegionalCollectionPage() && link.closest('#product-grid, #ProductGridContainer')) return; // keep regional collection grid links intact
    var href = link.getAttribute('href');
    if (!href || (href.indexOf('/collections/') < 0 && href.indexOf('/products/') < 0)) return;
    if (link.closest('#zip-code-popup')) return;

    var match = href.match(/^(\/(?:collections|products)\/)([^/?]+)([^]*)$/);
    if (!match) return;
    var prefix = match[1];
    var handle = match[2];
    var rest = match[3];
    var base = getHandleBase(handle);
    if (!base) return;

    var newHandle = region === 'la' ? base : (base + '-' + region);
    if (newHandle === handle) return;

    var isBrokenHandle = (handle.slice(-1) === '-' && !/-(?:la|sf|hnl|vc)$/i.test(handle));
    if (!link.getAttribute(ORIGINAL_HREF) && !isBrokenHandle) {
      link.setAttribute(ORIGINAL_HREF, href);
    }
    link.setAttribute('href', prefix + newHandle + rest);
    link.setAttribute(REWRITTEN_ATTR, region);
  }

  // Pricing note:
  // We no longer adjust prices via JavaScript.
  // Each city has its own duplicated products with correct prices in Shopify,
  // so we keep theme-rendered prices as-is.
  function applyPrices() {}

  function stripCitySuffix(text) {
    if (!text) return text;
    return String(text).replace(/\s*-\s*(Los Angeles|San Francisco|Honolulu|Ventura County)\s*$/i, '').trim();
  }

  /** Hide city suffix in product titles across site (cards, predictive search, etc.). */
  function hideCityNamesInTitles() {
    var nodes = document.querySelectorAll(
      [
        '.card__heading a.full-unstyled-link',
        '.card__heading a',
        '.predictive-search__list-item a',
        '[id^="predictive-search-option-product-"] a',
        'a.full-unstyled-link'
      ].join(',')
    );

    nodes.forEach(function (el) {
      if (el.closest('#zip-code-popup')) return;
      if (el.classList && (el.classList.contains('zip-popup-city-btn') || el.classList.contains('zip-popup-trigger'))) return;

      // Don't destroy markup / links: only update plain-text elements.
      if (el.querySelector && el.querySelector('*')) return;

      var t = el.textContent;
      var cleaned = stripCitySuffix(t);
      if (cleaned !== t) el.textContent = cleaned;
    });
  }

  /** Restore link to original href (when region is "other"). Never restore to broken "handle-" URL. */
  function restoreLink(link) {
    var orig = link.getAttribute(ORIGINAL_HREF);
    if (!orig) return;
    var handleMatch = orig.match(/\/(?:collections|products)\/([^/?]+)/);
    if (handleMatch && handleMatch[1].slice(-1) === '-' && !/-(?:la|sf|hnl|vc)$/i.test(handleMatch[1])) return;
    link.setAttribute('href', orig);
    link.removeAttribute(ORIGINAL_HREF);
    link.removeAttribute(REWRITTEN_ATTR);
  }

  /** Rewrite all collection/product links to current region, or restore if region is other */
  function rewriteLinksToRegion(region) {
    var links = document.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]');
    links.forEach(function (link) {
      if (link.closest('#zip-code-popup')) return;
      if (region) {
        rewriteLink(link, region);
      } else {
        restoreLink(link);
      }
    });
  }

  function applyRegion(city) {
    var region = cityToRegion(city);
    document.body.setAttribute(BODY_ATTR, region || 'other');
    document.body.classList.remove('store-city-la', 'store-city-sf', 'store-city-hnl', 'store-city-other');
    document.body.classList.add('store-city-' + (region || 'other'));
    rewriteLinksToRegion(region);
    hideDuplicateCards(region || 'la');
    applyPrices(city);
    hideCityNamesInTitles();
  }

  function runPopup() {
    var popup = document.getElementById('zip-code-popup');
    var input = document.getElementById('zip-code-input');
    var btn = document.getElementById('zip-code-submit');
    var err = document.getElementById('zip-code-error');
    if (!popup || !input || !btn) return;

    function closePopup() {
      popup.classList.remove('zip-popup--open');
      document.body.classList.remove('zip-popup-open');
    }

    function openPopup() {
      popup.classList.add('zip-popup--open');
      document.body.classList.add('zip-popup-open');
    }

    function applyCity(city) {
      setCookie(COOKIE_NAME, city, COOKIE_DAYS);
      closePopup();
      if (typeof window.zipCityApplied === 'function') window.zipCityApplied(city);
      redirectWithCitySaved(city);
    }

    function getReturnToUrlForCity(city) {
      if (isHomePath()) {
        return homeUrlWithCityQuery(city);
      }
      return window.location.pathname + (window.location.search || '') + (window.location.hash || '');
    }

    function redirectWithCitySaved(city) {
      // IMPORTANT:
      // Liquid can only read the selected city from cart.attributes.
      // Using /cart/update?...&return_to=... guarantees attributes are persisted BEFORE the next page render.
      var shortCity = city === 'los_angeles' ? 'la' : (city === 'san_francisco' ? 'sf' : (city === 'honolulu' ? 'hnl' : (city === 'ventura' ? 'vc' : 'other')));
      var returnTo = getReturnToUrlForCity(city);

      // Build query string without relying on URLSearchParams (older browsers).
      var qs =
        'attributes%5Bstore_city%5D=' + encodeURIComponent(city) +
        '&attributes%5Bselected_city%5D=' + encodeURIComponent(shortCity) +
        '&return_to=' + encodeURIComponent(returnTo);

      window.location.href = '/cart/update?' + qs;
    }

    function saveCityToCart(city) {
      var attr = { store_city: city };
      var shortCity = city === 'los_angeles' ? 'la' : (city === 'san_francisco' ? 'sf' : (city === 'honolulu' ? 'hnl' : (city === 'ventura' ? 'vc' : 'other')));
      attr.selected_city = shortCity;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attr })
      }).catch(function () {});
    }

    btn.addEventListener('click', function () {
      var zip = (input.value || '').trim();
      err && (err.textContent = '');
      if (!zip) {
        err && (err.textContent = 'Please enter your ZIP code.');
        return;
      }
      var city = getCityByZip(zip);
      if (!city) {
        err && (err.textContent = 'Please enter a valid US ZIP code.');
        return;
      }
      applyCity(city);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') btn.click();
    });

    popup.querySelectorAll('.zip-popup-close').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    popup.querySelectorAll('.zip-popup-city-btn').forEach(function (el) {
      el.addEventListener('click', function () {
        var city = el.getAttribute('data-city');
        if (city) { err && (err.textContent = ''); applyCity(city); }
      });
    });

    document.querySelectorAll('[data-open-zip-popup], #zip-popup-trigger').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openPopup(); });
    });

    var saved = getCityForRewrite();
    if (saved && cityToRegion(saved)) {
      if (!getCookie(COOKIE_NAME) && getCityFromUrl()) setCookie(COOKIE_NAME, saved, COOKIE_DAYS);
      closePopup();
      applyRegion(saved);
      // Best-effort sync for future server-side renders (no redirect here).
      if (getCookie(COOKIE_NAME)) saveCityToCart(saved);
      updateTriggerLabel(saved);
      if (isHomePath()) {
        if (saved === 'los_angeles' && (window.location.search || window.location.hash)) {
          history.replaceState(null, '', '/');
        } else if (saved === 'honolulu' || saved === 'san_francisco' || saved === 'ventura') {
          var prettyHome = homeUrlWithCityQuery(saved);
          var normPath = (window.location.pathname || '/').replace(/\/$/, '') || '/';
          var params = typeof URLSearchParams !== 'undefined' && window.location.search ? new URLSearchParams(window.location.search) : null;
          var fromQuery = params ? slugToCity(params.get('city')) : null;
          var hashSeg = (window.location.hash || '').replace(/^#/, '').split(/[?&]/)[0];
          var fromHash = hashSeg ? slugToCity(decodeURIComponent(hashSeg)) : null;
          var queryOk = fromQuery === saved;
          var pathOk = normPath === '/' || normPath === '';
          if (!pathOk || !queryOk || fromHash || window.location.hash) {
            history.replaceState(null, '', prettyHome);
          }
        }
      }
    } else {
      if (isHomePath()) {
        setTimeout(function () { openPopup(); }, 3000);
      } else {
        openPopup();
      }
    }

    var trigger = document.getElementById('zip-popup-trigger');
    if (trigger) {
      var searchEl = document.querySelector('.global-header .header__search, header .header__search, .header__search, [class*="global-header"] details-modal, [class*="header"] [class*="search"]');
      var iconsWrap = document.querySelector('.header__icons, .header-icons, [class*="global-header"] .header__icons');
      var ghActions = document.querySelector('.global-header .gh-actions, [class*="global-header"] .gh-actions');
      if (ghActions && ghActions.parentNode) {
        ghActions.insertBefore(trigger, ghActions.firstChild);
        trigger.classList.add('gh-inline');
      } else if (iconsWrap) {
        iconsWrap.insertBefore(trigger, iconsWrap.firstChild);
        trigger.classList.add('gh-inline');
      } else if (searchEl && searchEl.parentNode) {
        if (searchEl.nextSibling) {
          searchEl.parentNode.insertBefore(trigger, searchEl.nextSibling);
        } else {
          searchEl.parentNode.appendChild(trigger);
        }
        trigger.classList.add('gh-inline');
      }
      (function () {
        function isLightBg(el) {
          if (!el) return false;
          var style = window.getComputedStyle(el);
          var bg = style.backgroundColor;
          var opacity = parseFloat(style.opacity);
          if (bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') {
            var parent = el.parentElement;
            return parent ? isLightBg(parent) : false;
          }
          var m = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
          if (m) {
            var r = parseInt(m[1], 10), g = parseInt(m[2], 10), b = parseInt(m[3], 10);
            return (r * 0.299 + g * 0.587 + b * 0.114) > 200;
          }
          if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(bg)) {
            var hex = bg.slice(1).length === 3 ? bg.slice(1).replace(/./g, '$&$&') : bg.slice(1);
            var r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
            return (r * 0.299 + g * 0.587 + b * 0.114) > 200;
          }
          return false;
        }
        function updateTriggerLightBg() {
          if (!trigger || !trigger.classList.contains('gh-inline')) return;
          var header = trigger.closest('header, [class*="header"], [class*="Header"]');
          if (isLightBg(header || trigger.parentElement)) {
            trigger.classList.add('light-bg');
          } else {
            trigger.classList.remove('light-bg');
          }
        }
        updateTriggerLightBg();
        var scrollT = 0;
        window.addEventListener('scroll', function () {
          if (scrollT) clearTimeout(scrollT);
          scrollT = setTimeout(function () {
            scrollT = null;
            updateTriggerLightBg();
          }, 80);
        }, { passive: true });
      })();
    }

    window.openZipPopup = openPopup;
  }

  var rewriteDebounceTimer;
  function scheduleRewriteForNewContent() {
    if (rewriteDebounceTimer) clearTimeout(rewriteDebounceTimer);
    rewriteDebounceTimer = setTimeout(function () {
      rewriteDebounceTimer = null;
      var city = getCityForRewrite();
      if (city) applyRegion(city);
      else hideDuplicateCards('la');
      hideCityNamesInTitles();
    }, 150);
  }

  function observeDynamicContent() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var list = mutations[i].addedNodes;
        for (var j = 0; j < list.length; j++) {
          var node = list[j];
          if (node.nodeType !== 1) continue;
          if (node.querySelector && (node.querySelector('a[href*="/products/"]') || node.querySelector('a[href*="/collections/"]'))) {
            scheduleRewriteForNewContent();
            break;
          }
          if (node.getAttribute && node.getAttribute('href') && (node.getAttribute('href').indexOf('/products/') >= 0 || node.getAttribute('href').indexOf('/collections/') >= 0)) {
            scheduleRewriteForNewContent();
            break;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    runPopup();
    observeDynamicContent();
    var _c = getCityForRewrite();
    hideDuplicateCards((_c && cityToRegion(_c)) || 'la');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.getZipCity = getCookie.bind(null, COOKIE_NAME);
  window.getCityByZip = getCityByZip;
  window.cityToRegion = cityToRegion;
  window.applyRegion = applyRegion;
  window.applyPrices = applyPrices;
  window.rewriteLinksToRegion = rewriteLinksToRegion;
  // Backwards compat: some older code referenced this symbol.
  window.adjustPriceForNonLA = function () {};

  // === LOCAL HEADING BY ZIP CODE ===
  var ZIP_LOCAL_NAMES = {
    // SF Bay Area neighborhoods
    '94701': 'Berkeley', '94702': 'Berkeley', '94703': 'Berkeley', '94704': 'Berkeley',
    '94705': 'Berkeley', '94706': 'Albany', '94707': 'Berkeley', '94708': 'Berkeley',
    '94709': 'Berkeley', '94710': 'Berkeley', '94720': 'Berkeley',
    '94601': 'Oakland', '94602': 'Oakland', '94603': 'Oakland', '94604': 'Oakland',
    '94605': 'Oakland', '94606': 'Oakland', '94607': 'Oakland', '94608': 'Emeryville',
    '94609': 'Oakland', '94610': 'Oakland', '94611': 'Oakland', '94612': 'Oakland',
    '94613': 'Oakland', '94614': 'Oakland', '94615': 'Oakland', '94618': 'Oakland',
    '94619': 'Oakland', '94621': 'Oakland', '94622': 'Oakland', '94623': 'Oakland',
    '94624': 'Oakland', '94625': 'Oakland', '94649': 'Oakland', '94660': 'Oakland',
    '94661': 'Oakland', '94662': 'Oakland',
    '94501': 'Alameda', '94502': 'Alameda',
    '94801': 'Richmond', '94802': 'Richmond', '94803': 'El Sobrante',
    '94804': 'Richmond', '94805': 'Richmond', '94806': 'San Pablo', '94820': 'El Cerrito',
    '94530': 'El Cerrito',
    '94577': 'San Leandro', '94578': 'San Leandro', '94579': 'San Leandro',
    '94580': 'San Lorenzo',
    '94541': 'Hayward', '94542': 'Hayward', '94544': 'Hayward', '94545': 'Hayward',
    '94546': 'Castro Valley', '94552': 'Castro Valley',
    '94555': 'Fremont',
    '94507': 'Alamo', '94526': 'Danville', '94528': 'Danville',
    '94549': 'Lafayette', '94556': 'Moraga', '94563': 'Orinda',
    '94595': 'Walnut Creek', '94596': 'Walnut Creek', '94597': 'Walnut Creek', '94598': 'Walnut Creek',
    '94518': 'Concord', '94523': 'Pleasant Hill', '94553': 'Martinez',
    '94901': 'San Rafael', '94903': 'San Rafael', '94904': 'Greenbrae',
    '94920': 'Tiburon', '94925': 'Corte Madera', '94939': 'Larkspur',
    '94941': 'Mill Valley', '94960': 'San Anselmo', '94965': 'Sausalito',
    '94014': 'Daly City', '94015': 'Daly City', '94016': 'Daly City',
    '94080': 'South San Francisco', '94083': 'South San Francisco',
    '94044': 'Pacifica', '94066': 'San Bruno', '94030': 'Millbrae',
    '94010': 'Burlingame', '94401': 'San Mateo', '94402': 'San Mateo',
    '94403': 'San Mateo', '94404': 'Foster City',
    '94002': 'Belmont', '94070': 'San Carlos', '94065': 'Redwood Shores',
    '94061': 'Redwood City', '94062': 'Redwood City', '94063': 'Redwood City',
    '94028': 'Portola Valley',
    // SF proper
    '94102': 'San Francisco', '94103': 'San Francisco', '94104': 'San Francisco',
    '94105': 'San Francisco', '94107': 'San Francisco', '94108': 'San Francisco',
    '94109': 'San Francisco', '94110': 'San Francisco', '94111': 'San Francisco',
    '94112': 'San Francisco', '94114': 'San Francisco', '94115': 'San Francisco',
    '94116': 'San Francisco', '94117': 'San Francisco', '94118': 'San Francisco',
    '94121': 'San Francisco', '94122': 'San Francisco', '94123': 'San Francisco',
    '94124': 'San Francisco', '94127': 'San Francisco', '94129': 'San Francisco',
    '94130': 'San Francisco', '94131': 'San Francisco', '94132': 'San Francisco',
    '94133': 'San Francisco', '94134': 'San Francisco', '94158': 'San Francisco',
    // LA neighborhoods
    '90210': 'Beverly Hills', '90211': 'Beverly Hills', '90212': 'Beverly Hills',
    '90046': 'West Hollywood', '90069': 'West Hollywood', '90048': 'Beverly Grove',
    '90028': 'Hollywood', '90038': 'Hollywood', '90068': 'Hollywood Hills',
    '90401': 'Santa Monica', '90402': 'Santa Monica', '90403': 'Santa Monica',
    '90404': 'Santa Monica', '90405': 'Santa Monica',
    '90291': 'Venice', '90292': 'Marina Del Rey', '90293': 'Playa Del Rey',
    '90049': 'Brentwood', '90077': 'Bel Air',
    '90230': 'Culver City', '90232': 'Culver City',
    '90272': 'Pacific Palisades', '90290': 'Topanga', '90265': 'Malibu',
    '91101': 'Pasadena', '91103': 'Pasadena', '91104': 'Pasadena',
    '91105': 'Pasadena', '91106': 'Pasadena', '91107': 'Pasadena',
    '91030': 'South Pasadena', '91108': 'San Marino',
    '91201': 'Glendale', '91202': 'Glendale', '91203': 'Glendale',
    '91204': 'Glendale', '91205': 'Glendale', '91206': 'Glendale',
    '91207': 'Glendale', '91208': 'Glendale',
    '91501': 'Burbank', '91502': 'Burbank', '91504': 'Burbank',
    '91505': 'Burbank', '91506': 'Burbank',
    '90501': 'Torrance', '90502': 'Torrance', '90503': 'Torrance',
    '90504': 'Torrance', '90505': 'Torrance', '90506': 'Torrance',
    '90301': 'Inglewood', '90302': 'Inglewood', '90303': 'Inglewood', '90305': 'Inglewood',
    '90245': 'El Segundo', '90266': 'Manhattan Beach',
    '90254': 'Hermosa Beach', '90277': 'Redondo Beach', '90278': 'Redondo Beach',
    '90274': 'Palos Verdes', '90275': 'Rancho Palos Verdes',
    '90731': 'San Pedro', '90732': 'San Pedro',
    '90802': 'Long Beach', '90803': 'Long Beach', '90804': 'Long Beach',
    '90805': 'Long Beach', '90806': 'Long Beach', '90807': 'Long Beach',
    '90808': 'Long Beach', '90810': 'Long Beach', '90813': 'Long Beach',
    '90814': 'Long Beach', '90815': 'Long Beach',
    '91601': 'North Hollywood', '91602': 'North Hollywood', '91604': 'Studio City',
    '91605': 'North Hollywood', '91606': 'North Hollywood', '91607': 'Valley Village',
    '91401': 'Van Nuys', '91402': 'Panorama City', '91403': 'Sherman Oaks',
    '91405': 'Van Nuys', '91406': 'Van Nuys', '91423': 'Sherman Oaks',
    '91436': 'Encino', '91316': 'Encino',
    '91356': 'Tarzana', '91364': 'Woodland Hills', '91367': 'Woodland Hills',
    '90094': 'Playa Vista', '90045': 'Westchester',
    '90220': 'Compton', '90221': 'Compton', '90222': 'Compton',
    '90240': 'Downey', '90241': 'Downey', '90242': 'Downey',
    '90250': 'Hawthorne', '90260': 'Lawndale',
    '90640': 'Montebello', '90660': 'Pico Rivera', '90280': 'South Gate',
    '90255': 'Huntington Park', '90201': 'Bell',
    '90601': 'Whittier', '90602': 'Whittier', '90603': 'Whittier',
    '90604': 'Whittier', '90605': 'Whittier', '90606': 'Whittier',
    '91754': 'Monterey Park', '91755': 'Monterey Park',
    '91001': 'Altadena', '91011': 'La Cañada Flintridge',
    '91040': 'Sunland', '91042': 'Tujunga',
    '91331': 'Pacoima', '91340': 'San Fernando', '91342': 'Sylmar',
    '91344': 'Granada Hills', '91324': 'Northridge', '91325': 'Northridge',
    '91311': 'Chatsworth', '91345': 'Mission Hills',
    // HNL neighborhoods
    '96701': 'Aiea', '96706': 'Ewa Beach', '96707': 'Kapolei',
    '96712': 'Haleiwa', '96717': 'Hauula', '96734': 'Kailua',
    '96744': 'Kaneohe', '96782': 'Pearl City', '96786': 'Wahiawa',
    '96789': 'Mililani', '96791': 'Waialua', '96792': 'Waianae',
    '96795': 'Waimanalo', '96797': 'Waipahu',
    '96813': 'Honolulu', '96814': 'Honolulu', '96815': 'Waikiki',
    '96816': 'Honolulu', '96817': 'Honolulu', '96818': 'Honolulu',
    '96819': 'Honolulu', '96821': 'Hawaii Kai', '96822': 'Honolulu',
    '96825': 'Hawaii Kai', '96826': 'Honolulu',
    '91320': 'Newbury Park', '93012': 'Camarillo', '91360': 'Thousand Oaks', '91361': 'Westlake Village', '91362': 'Thousand Oaks', '93010': 'Camarillo', '93033': 'Oxnard', '93042': 'Port Hueneme', '90265': 'Malibu', '91301': 'Agoura Hills', '91363': 'Woodland Hills', '91377': 'Oak Park', '93004': 'Ventura', '93021': 'Moorpark', '93030': 'Oxnard', '93035': 'Oxnard', '93036': 'Oxnard', '93041': 'Port Hueneme', '93043': 'Port Hueneme', '93066': 'Somis', '90263': 'Malibu', '91302': 'Calabasas', '91307': 'West Hills', '93003': 'Ventura', '93060': 'Santa Paula', '93063': 'Simi Valley', '93064': 'Simi Valley', '93065': 'Simi Valley', '93093': 'Simi Valley', '93099': 'Simi Valley', '91303': 'Canoga Park', '91304': 'Canoga Park', '91311': 'Chatsworth', '91367': 'Woodland Hills', '93009': 'Ventura', '93015': 'Fillmore', '91355': 'Valencia', '91381': 'Stevenson Ranch', '93001': 'Ventura', '93022': 'Oak View'
  };

  function getLocalName(zip) {
    return ZIP_LOCAL_NAMES[String(zip)] || null;
  }

  function updateHeroHeading(zip) {
    var localName = getLocalName(zip);
    if (!localName) return;

    var headingText = localName.toUpperCase() + ' FLORIST';

    var blocks = document.querySelectorAll('.region-slideshow');
    var visibleBlock = null;
    for (var i = 0; i < blocks.length; i++) {
      if (getComputedStyle(blocks[i]).display !== 'none') {
        visibleBlock = blocks[i];
        break;
      }
    }
    if (!visibleBlock) return;

    var heading = visibleBlock.querySelector('.ami-slideshow__item-content h1, .ami-slideshow__item-content h2');
    if (heading) heading.innerHTML = '<strong>' + headingText + '</strong>';

    var subtitle = visibleBlock.querySelector('.ami-slideshow__item-content aside h3');
    if (subtitle) subtitle.innerHTML = '<strong>Event decorations and flower delivery in ' + localName + '</strong>';
  }

  document.addEventListener('click', function(e) {
    var btn = document.getElementById('zip-code-submit');
    if (!btn) return;
    if (e.target === btn || (e.target.closest && e.target.closest('#zip-code-submit'))) {
      var input = document.getElementById('zip-code-input');
      var zip = input ? (input.value || '').trim() : '';
      if (zip && /^\d{5}$/.test(zip)) {
        localStorage.setItem('pc_selected_zip', zip);
      }
    }
  }, true);

  var CITY_PHONES = {
    la: '(424) 303-2205',
    sf: '(415) 360-1333',
    hnl: '(808) 808-6616',
    vc: '(805) 870-9996'
  };

  function updateAnnouncementPhone(city) {
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    var phone = CITY_PHONES[suffix] || CITY_PHONES.la;
    var textEl = document.getElementById('announcement-phone-text');
    var linkEl = document.getElementById('announcement-phone-link');
    if (textEl) textEl.textContent = phone;
    if (linkEl) linkEl.href = 'tel:+1' + phone.replace(/[^0-9]/g, '');
  }

  var origApplyCity = window.applyRegion;
  window.applyRegion = function(city) {
    if (origApplyCity) origApplyCity(city);
    showCityTextSections(city);
    updateAnnouncementPhone(city);
    updateCollectionRegion(city);
    updateFooterRegion(city);
    var zip = localStorage.getItem('pc_selected_zip') || '';
    if (zip) {
      var zipCity = getCityByZip(zip);
      if (zipCity === city) {
        updateHeroHeading(zip);
      } else {
        localStorage.removeItem('pc_selected_zip');
      }
    }
  };



  function updateFooterRegion(city) {
    var names = { la: 'Los Angeles', sf: 'San Francisco', hnl: 'Honolulu', vc: 'Ventura County' };
    var delivHref = { la: '/pages/flower-delivery-la', sf: '/pages/san-francisco', hnl: '/collections/main-collection-hnl', vc: '/collections/main-collection-vc' };
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    var name = names[suffix];
    var links = document.querySelectorAll('.footer a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.hasAttribute('data-pc-orig')) {
        if (a.textContent.indexOf('Los Angeles') === -1) continue;
        a.setAttribute('data-pc-orig', a.textContent);
        a.setAttribute('data-pc-orig-href', a.getAttribute('href') || '');
      }
      var orig = a.getAttribute('data-pc-orig');
      a.textContent = orig.replace(/Los Angeles/g, name);
      if (orig.indexOf('Flower Delivery') !== -1) {
        a.setAttribute('href', delivHref[suffix] || a.getAttribute('data-pc-orig-href'));
      }
    }
  }
  window.updateFooterRegion = updateFooterRegion;

  function updateCollectionRegion(city) {
    // Region from collection URL (collection's own region); else visitor city
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    var pcm = window.location.pathname.match(/\/collections\/[^\/]*-(vc|hnl|sf)(?:\/|$)/);
    if (pcm) suffix = pcm[1];
    if (suffix === 'la') return; // LA: nothing to localize
    var names = { sf: 'San Francisco', hnl: 'Honolulu', vc: 'Ventura County' };
    var across = { sf: 'the Bay Area', hnl: 'Oahu', vc: 'Ventura County' };
    var name = names[suffix], acr = across[suffix];
    // Replace via TEXT NODES only (nodeValue change = no childList mutation -> no observer loop -> grid stays intact)
    function swapText(root) {
      if (!root || root.getAttribute('data-pc-localized')) return;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue;
        if (v.indexOf('Los Angeles') !== -1 || v.indexOf('LOS ANGELES') !== -1 || /across LA\b/.test(v)) {
          n.nodeValue = v.replace(/LOS ANGELES/g, name.toUpperCase()).replace(/Los Angeles/g, name).replace(/across LA\b/g, 'across ' + acr);
        }
      }
      root.setAttribute('data-pc-localized', '1');
    }
    swapText(document.querySelector('[id$="__image_with_text_TdnByX"]'));
    swapText(document.querySelector('[id$="__rich_text_QKwxPW"]'));
  }
  window.updateCollectionRegion = updateCollectionRegion;

  function showCityTextSections(city) {
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';

    var pairs = [
      ['__image_with_content_XfFXaY', 'la'],
      ['__image_with_content_XfFXaY_SF', 'sf'],
      ['__image_with_content_XfFXaY_HNL', 'hnl'],
      ['__image_with_content_XfFXaY_VC', 'vc']
    ];
    for (var i = 0; i < pairs.length; i++) {
      var el = document.querySelector('[id$="' + pairs[i][0] + '"]');
      if (el) el.style.display = (pairs[i][1] === suffix) ? '' : 'none';
    }

    // Region-variant content INSIDE a section via inner [data-pc-region] blocks (HNL -> LA fallback)
    var innerSections = ['__home_locations_div', '__home_faq_brand_v2'];
    var want = (suffix === 'sf' || suffix === 'vc' || suffix === 'hnl') ? suffix : 'la';
    for (var s = 0; s < innerSections.length; s++) {
      var sec = document.querySelector('[id$="' + innerSections[s] + '"]');
      if (!sec) continue;
      var regs = sec.querySelectorAll('[data-pc-region]');
      if (!regs.length) continue;
      var has = false;
      for (var q = 0; q < regs.length; q++) { if (regs[q].getAttribute('data-pc-region') === want) { has = true; break; } }
      var show = has ? want : 'la';
      for (var r = 0; r < regs.length; r++) {
        regs[r].style.display = (regs[r].getAttribute('data-pc-region') === show) ? '' : 'none';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var city = getCookie(COOKIE_NAME) || getCityFromUrl() || (window.__STORE_CITY_FROM_CART__) || null;
    if (city) {
      showCityTextSections(city);
      updateAnnouncementPhone(city);
      updateCollectionRegion(city);
      updateFooterRegion(city);
    updateFooterRegion(city);
    } else {
      showCityTextSections('los_angeles');
      updateAnnouncementPhone('los_angeles');
      updateCollectionRegion('los_angeles');
      updateFooterRegion('los_angeles');
    }
    var zip = localStorage.getItem('pc_selected_zip') || '';
    if (zip) {
      var currentCity = city || 'los_angeles';
      var zipCity = getCityByZip(zip);
      if (zipCity === currentCity) {
        setTimeout(function() { updateHeroHeading(zip); }, 600);
      } else {
        localStorage.removeItem('pc_selected_zip');
      }
    }
  });

  window.updateHeroHeading = updateHeroHeading;
  window.getLocalName = getLocalName;
  window.showCityTextSections = showCityTextSections;

})();
